import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../../modules/infra/i18n';
import CustomerForm from '../../CustomerForm';
import Modal from '../../../Modal';

const AddCustomerModal = ({ close, onSubmit }) => (
  <Modal
    title={t('register:customer.add_customer_modal.title')}
    close={close}
  >
    <div className="u-pv+ u-ph++">
      <CustomerForm submitButtonText={t('register:customer.add_customer_modal.submit_button')} onSubmit={onSubmit} />
    </div>
  </Modal>
);
AddCustomerModal.propTypes = {
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AddCustomerModal;
